/* Goal page v2 behaviours. No storage APIs. All motion respects reduced-motion. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Result figures reveal on entry */
  var cards=document.querySelectorAll('.cgResult');
  if(cards.length && 'IntersectionObserver' in window && !reduce){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{rootMargin:'0px 0px -12% 0px'});
    cards.forEach(function(c){io.observe(c);});
  } else {
    cards.forEach(function(c){c.classList.add('is-in');});
  }

  /* SEE STUDY → open the matching accordion and scroll to it */
  document.querySelectorAll('[data-open]').forEach(function(a){
    a.addEventListener('click',function(ev){
      var el=document.getElementById(a.getAttribute('data-open'));
      if(!el) return;
      ev.preventDefault();
      el.open=true;
      el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
    });
  });
})();
